import { Button, Modal } from 'antd';

export default function GuestCheckoutInfoModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={'min(95%, 36rem)'}
      title={null}
      footer={null}
      closable={false}
      maskClosable
      centered
    >
      <div className='txt-center fs-16 gMedium pd-20'>
        <h1 className='gBold fs-24'>How does Guest Checkout Work?</h1>
        <p>
          You can now book all public venues on swimbooker without logging in or
          creating a swimbooker account.
        </p>
        <h2 className='gSemiBold fs-20 sb-blue-600 mg-top-30'>
          I have an <b className='gBold'>existing swimbooker account</b>{' '}
          and would like my booking linked
        </h2>
        <p>
          No problem! Either log in to your account prior to booking or when
          entering your booking details on the final step, enter the{' '}
          <b className='gSemiBold'>
            same email as registered on your SB account
          </b>
          . If entered correctly, we will assign the booking to your account.
        </p>
        <h2 className='gSemiBold fs-20 sb-blue-600 mg-top-30'>
          I am a <b className='gBold'>member or season ticket holder</b> of a
          venue
        </h2>
        <p>
          If you wish to access member only lakes or your season ticket
          privileges, you will need to log into your existing swimbooker account
          prior to booking.
        </p>
        <Button
          style={{ maxWidth: 'clamp(20rem, 75%, 100%)'}}
          className='sb-blue-gradient-bg-right white gSemiBold brFull fs-18 sb-blue-700 txt-center w-full pd-10 mg-top-20 h-fit txt-wrap'
           onClick={onClose}>Back</Button>
      </div>
    </Modal>
  );
}
